/* jshint esversion: 9 */
/**
 * Goods Stock Manage : 库存管理
 *
 *
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/stock/v1/{organizationId}/goods-stocks',
  items: [
    // 查看仓库库存
    { key: 'getGoodsStockList', url: '/stock-list', method: 'POST' },
    // 分页  仓库库存表列表
    { key: 'getGoodsStockPage', url: '/page', method: 'POST' },
    // 分页  仓库库存表列表（三合一）
    { key: 'getGoodsStockPageCSG', url: '/pageCsg', method: 'POST' },
    // 子商品的可用数量
    { key: 'getGoodsStockSkuNum', url: '/sku-num', method: 'POST' },
    // 导出  仓库库存表
    { key: 'exportGoodsStock', url: '/stock-page-export', method: 'POST' },
    // 私人导出
    { key: 'stockLRIExport', url: '/stock-lri-export', method: 'POST' },
  ],
};
export default {
  ...generate(config),
};
